import { useEffect, type ReactNode } from 'react';
import { Navbar } from '@/Components/Navbar';
import { Footer } from '@/Components/Footer';
import { siteConfig } from '@/config/site';

interface AppLayoutProps {
    children: ReactNode;
    title?: string;
    description?: string;
}

export default function AppLayout({ children, title, description }: AppLayoutProps) {
    useEffect(() => {
        const fullTitle = title
            ? `${title} - ${siteConfig.brand.name}`
            : `${siteConfig.brand.name} - ${siteConfig.brand.tagline}`;
        document.title = fullTitle;

        if (description) {
            let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
            if (!meta) {
                meta = document.createElement('meta');
                meta.name = 'description';
                document.head.appendChild(meta);
            }
            meta.content = description;
        }
    }, [title, description]);

    return (
        <>
            <Navbar />
            <main>{children}</main>
            <Footer />
        </>
    );
}
